/**
 * LiquidGlass Variants
 *
 * CVA variants for the LiquidGlass component.
 * Exported separately to comply with React Fast Refresh requirements.
 *
 * @see LiquidGlass.tsx for component implementation
 */

import {cva} from 'class-variance-authority';

export const liquidGlassVariants = cva(
  [
    'relative overflow-hidden',
    'backdrop-saturate-[180%]',
    'transition-all duration-morph ease-liquid',
  ].join(' '),
  {
    variants: {
      /**
       * Glass material thickness/opacity level
       */
      thickness: {
        thin: 'liquid-glass-thin',
        regular: 'liquid-glass',
        thick: 'liquid-glass-thick',
        ultra: 'liquid-glass-ultra',
      },
      /**
       * Border radius
       */
      rounded: {
        none: 'rounded-none',
        sm: 'rounded-lg',
        md: 'rounded-xl',
        lg: 'rounded-2xl',
        xl: 'rounded-3xl',
        full: 'rounded-full',
        responsive: 'rounded-xl sm:rounded-2xl lg:rounded-3xl',
      },
      /**
       * Padding
       */
      padding: {
        none: 'p-0',
        sm: 'p-3 sm:p-4',
        md: 'p-4 sm:p-5 lg:p-6',
        lg: 'p-5 sm:p-6 lg:p-8',
        xl: 'p-6 sm:p-8 lg:p-10',
        responsive: 'p-4 sm:p-6 lg:p-8',
      },
      /**
       * Interactive behavior (hover/active states)
       */
      interactive: {
        true: 'fluid-control cursor-pointer',
        false: '',
      },
      /**
       * Apple-style specular highlight (top shine)
       */
      specular: {
        true: 'liquid-glass-specular',
        false: '',
      },
      /**
       * Entry animation
       */
      animate: {
        none: '',
        appear: 'animate-fluid-appear',
        morph: 'animate-morph-expand',
        shimmer: 'animate-glass-shimmer-slide',
      },
      /**
       * Shadow intensity
       */
      shadow: {
        none: 'shadow-none',
        sm: 'shadow-liquid-glass-sm',
        md: 'shadow-liquid-glass',
        lg: 'shadow-liquid-glass-lg',
      },
    },
    defaultVariants: {
      thickness: 'regular',
      rounded: 'lg',
      padding: 'md',
      interactive: false,
      specular: false,
      animate: 'none',
      shadow: 'md',
    },
  }
);
